import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styles from './DetailInfoButton.module.css'

const DetailInfoButton = ({
  iboNumber = '',
  label = 'LOS', // initial state: 'Detail' or 'LOS'
  display, // localized display text for the initial state
  onLosClick = () => {},
  onDetailClick = () => {},
  onBackClick = () => {},
  showBack = false,
  autoToggle = true,
}) => {
  const initial = (label || 'LOS').toLowerCase()
  const [current, setCurrent] = useState(initial)

  const initialText = typeof display === 'string' && display.length > 0 ? display : label
  const otherText = initial === 'detail' ? 'LOS' : 'Detail'
  const text = current === initial ? initialText : otherText

  const handleBack = () => onBackClick()

  const handleAction = () => {
    if (current === 'detail') {
      onDetailClick()
    } else {
      onLosClick()
    }

    if (autoToggle) setCurrent(current === 'detail' ? 'los' : 'detail')
  }

  return (
    <div className={styles.container} role="group" aria-label="Detail info button group" data-ibo={iboNumber}>
      {showBack && (
        <button className={styles.iconButton} data-label="back" onClick={handleBack} aria-label="Back">
          ‹
        </button>
      )}

      <button
        className={styles.actionButton}
        data-label={current}
        data-ibo={iboNumber}
        onClick={handleAction}
        aria-label={text}
      >
        {text}
      </button>
    </div>
  )
}

DetailInfoButton.propTypes = {
  iboNumber: PropTypes.string,
  label: PropTypes.string,
  display: PropTypes.string,
  onLosClick: PropTypes.func,
  onDetailClick: PropTypes.func,
  onBackClick: PropTypes.func,
  showBack: PropTypes.bool,
  autoToggle: PropTypes.bool,
}

export default DetailInfoButton
